export default __webpack_public_path__ + "static/media/group.0b2fd46b.svg";